import React from "react";
var InputRadioContext = React.createContext(null);
export var useInputRadioGroup = function () { return React.useContext(InputRadioContext); };
export default InputRadioContext;
